module.exports = __webpack_public_path__ + "static/room1-3-c295ff65cac4b6bb6de090e4a7959220.jpg";